export const convertAccessLevelForBackend = (accessLevel) => {
  switch (accessLevel) {
    case 'Full Access':
      return 'Full';
    case 'Remove Access':
      return 'Remove';
    case 'Duplicate':
      return 'AutoCopy';
    default:
      return accessLevel;
  }
};

export const convertAccessLevelForFrontend = (accessLevel) => {
  switch (accessLevel) {
    case 'Full':
      return 'Collaborate';
    case 'Remove':
      return 'Remove Access';
    case 'AutoCopy':
      return 'Duplicate';
    default:
      return accessLevel;
  }
};

export const convertToArray = (sharedAccessData) => {
  return Object.entries(sharedAccessData).map(([email, access]) => ({
    email,
    access: convertAccessLevelForFrontend(access),
  }));
};

export const truncateText = (text, maxLength = 40) => {
  if (!text) return '';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

export const getEmrNoteTypeValues = (emrNoteType) => {
  if (Array.isArray(emrNoteType)) return emrNoteType;
  if (emrNoteType === null || emrNoteType === undefined) return [];
  return [emrNoteType];
};

export const getEmrNoteTypesLabel = (template, fallback = '') => {
  const noteTypes = getEmrNoteTypeValues(template?.emr_note_type);
  return noteTypes.length > 0 ? noteTypes.join(', ') : fallback;
};

export const getFirstEmrNoteType = (template, fallback = '') => {
  const noteTypes = getEmrNoteTypeValues(template?.emr_note_type);
  return noteTypes.length > 0 ? noteTypes[0] : fallback;
};

export const getEmrNoteTypePayload = (noteTypes) =>
  noteTypes.length === 1 ? noteTypes[0] : noteTypes;
